import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FlexRow } from '../../../../shared/FlexRow';
import { Body, Label } from '../../../../shared/styled-components/styled_text';

interface Props {
  title: string;
  content: string;
  isPhone?: boolean;
}

export const CompanyInfoContainer = ({ title, content, isPhone }: Props) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent));
  }, []);

  const handlePhoneClick = (phoneNumber: string) => {
    if (!isMobile || !phoneNumber) return;
    window.open(`tel:${phoneNumber}`, '_self');
  };

  return (
    <Container onClick={() => isPhone && handlePhoneClick(content)}>
      <FlexRow width={'100%'} justify={'flex-start'} align={'center'} gap={'0.4rem'}>
        <Label size={'s'} style={{ color: 'var(--content-color-tertiary)' }}>
          {title}
        </Label>
      </FlexRow>
      <Body size={'s'} style={{ width: '100%', textAlign: 'left' }}>
        {content}
      </Body>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  padding: 1.2rem;
  background-color: var(--mono-op-08);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 0.6rem;
`;
